import React, { createContext, useContext, useState, useCallback } from 'react';

const AudioPlayerContext = createContext(null);

export function AudioPlayerProvider({ children }) {
    const [tracks, setTracks] = useState([]);
    const [currentTrackId, setCurrentTrackId] = useState(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [isVisible, setIsVisible] = useState(false);

    const loadTracks = useCallback((newTracks) => {
        setTracks(newTracks);
        if (newTracks.length > 0 && !currentTrackId) {
            setCurrentTrackId(newTracks[0].id);
        }
        setIsVisible(true);
    }, [currentTrackId]);

    const playTrack = useCallback((trackId) => {
        setCurrentTrackId(trackId);
        setIsPlaying(true);
        setIsVisible(true);
        setIsCollapsed(false);
    }, []);

    const togglePlayPause = useCallback(() => {
        setIsPlaying(prev => !prev);
    }, []);

    const toggleCollapse = useCallback(() => {
        setIsCollapsed(prev => !prev);
    }, []);

    const hidePlayer = useCallback(() => {
        setIsVisible(false);
        setIsPlaying(false);
        setCurrentTrackId(null);
        setTracks([]);
    }, []);

    const value = {
        tracks,
        currentTrackId,
        isPlaying,
        isCollapsed,
        isVisible,
        loadTracks,
        playTrack,
        togglePlayPause,
        toggleCollapse,
        hidePlayer
    };

    return (
        <AudioPlayerContext.Provider value={value}>
            {children}
        </AudioPlayerContext.Provider>
    );
}

export function useAudioPlayer() {
    const context = useContext(AudioPlayerContext);
    if (!context) {
        throw new Error('useAudioPlayer must be used within an AudioPlayerProvider');
    }
    return context;
}
